import { apiClient } from "../api"
import { stringifyParams } from "../utils/api"
import { DTO_Sensor, DTO_SensorTemperatureSettingsContacts, DTO_SensorTemperatureSettings } from "./types/sensors"

const SENSOR = '/sensor/'
const SENSOR_TEMP_SETTINGS = '/sensortemperaturesettings/'
const SENSOR_TEMP_CONTACTS = '/sensortemperaturesettingscontacts/'

export const getSensors = (params?: Record<string, any>): Promise<DTO_Sensor[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${SENSOR}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const getSensorTemperatureSettings = (): Promise<DTO_SensorTemperatureSettings[]> => {
  const ac = apiClient()
  const promise = ac.get(SENSOR_TEMP_SETTINGS)
    .then(res => res.data)
  return promise
}

export const deleteSensorTemperatureSettings = (id: number) => {
  const ac = apiClient()
  const promise = ac.delete(`${SENSOR_TEMP_SETTINGS}${id}/`)
    .then(res => res.data)
  return promise
}

export const createSensorTemperatureSettings = (data: any) => {
  const ac = apiClient()
  const promise = ac.post(SENSOR_TEMP_SETTINGS, {
    ...data
  }).then(res => res.data)
  return promise
}

export const updateSensorTemperatureSettings = (id: number, data: any) => {
  const ac = apiClient()
  const promise = ac.patch(`${SENSOR_TEMP_SETTINGS}${id}/`, {
    ...data
  }).then(res => res.data)
  return promise
}

export const getSensorTemperatureSettingsContacts = (): Promise<DTO_SensorTemperatureSettingsContacts[]> => {
  const ac = apiClient()
  const promise = ac.get(SENSOR_TEMP_CONTACTS)
    .then(res => res.data)
  return promise
}

export const createSensorTemperatureSettingsContact = (data: DTO_SensorTemperatureSettingsContacts): Promise<any> => {
  const ac = apiClient()
  const promise = ac.post(SENSOR_TEMP_CONTACTS, {
    ...data
  }).then(res => res.data)
  return promise
}

export const deleteSensorTemperatureSettingsContact = (id: number): Promise<any> => {
  const ac = apiClient()
  const promise = ac.delete(`${SENSOR_TEMP_CONTACTS}${id}/`)
    .then(res => res.data)
  return promise
}